import qs from "qs";
import { useTheme } from "styled-components";

export function isClientSide(): Boolean {
  return typeof window !== "undefined";
}


export function qsStringify(
  queryStringObject: any,
  { encode = false, skipNulls = true, addQueryPrefix = true } = {}
): string {
  return qs.stringify(queryStringObject, {
    encode,
    skipNulls,
    addQueryPrefix,
  });
}

export const getScreensList = (lastNscreens) => {
  const filterScreens = (obj) => {
    if (obj.Screen) {
      return obj.Screen;
    }
  };
  if (isClientSide()) {
    // @ts-ignore
    return [...new Set(window.dataLayer || [].map(filterScreens))]
      .slice(-lastNscreens)
      .join(",");
  }
  return "";
};

export const deepMergeObjects = (obj1, obj2) => {
  //@todo refactor me
  if (!obj1) return obj2 || {};
  if (!obj2) return obj1 || {};

  const result = {};

  for (const key of Object.keys(obj1)) {
    if (key in obj2) {
      if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
        result[key] = [...new Set([...obj1[key], ...obj2[key]])];
      } else {
        result[key] = obj2[key];
      }
    } else {
      result[key] = obj1[key];
    }
  }

  for (const key of Object.keys(obj2)) {
    if (!(key in obj1)) {
      result[key] = obj2[key];
    }
  }

  return result;
};

export const flattenObject = (input) => {
  let result = {};
  for (const key in input) {
    if (!input.hasOwnProperty(key)) {
      continue;
    }
    if (typeof input[key] === "object" && !Array.isArray(input[key])) {
      var subFlatObject = flattenObject(input[key]);
      for (const subkey in subFlatObject) {
        result[key + "_" + subkey] = subFlatObject[subkey];
      }
    } else {
      result[key] = input[key];
    }
  }
  return result;
};


export const getMapUrl = (lat,lon) => {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`
}